var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('textarea',{staticClass:"tds-input--textarea",domProps:{"innerHTML":_vm._s(_vm.value)},on:{"change":_vm.emitInput}})}
var staticRenderFns = []

export { render, staticRenderFns }